import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className='footer'>
            <div className='footer-content'>
                {/* Logo */}
                <img src="/images/logo_letras.png" alt="Volteon Logo" className="footer-logo" />

                {/* Texto principal */}
                <p className='footer-text'>
                    En Volteon, transformamos tus proyectos en realidad, con los mejores <br />
                    componentes electrónicos
                </p>

                {/* Enlaces en una fila */}
                <ul className='footer-links'>
                    <li><Link to='/envios'>Información de envíos</Link></li>
                    <li><Link to='/reembolso'>Política de reembolso</Link></li>
                    <li><Link to='/PuntosdeVenta'>Puntos de venta</Link></li>
                </ul>

                {/* Teléfono */}
                <p className='footer-phone'>Teléfono: +506 6386-5580</p>

                {/* Iconos de redes sociales */}
                <div className='footer-icons'>
                    <a
                        href="https://www.facebook.com/volteonelectronics"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                    >
                        <FaFacebook className='icon' />
                    </a>

                    <a
                        href="https://www.instagram.com/volteon_electronics"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <FaInstagram className='icon' />
                    </a>

                    <a
                        href="https://wa.me/50663865580"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                    >
                        <FaWhatsapp className='icon' />
                    </a>
                </div>

                {/* Derechos reservados */}
                <p className='footer-rights'>All rights reserved, 2025</p>
            </div>
        </footer>
    );
};

export default Footer;
